export const logoLink = 'https://rocknblock.io';

export const navLinks = [
  { title: 'Portfolio', href: 'https://rocknblock.io/portfolio' },
  { title: 'Blog', href: 'https://rocknblock.io/blog' },
];

export const services = [
  { title: 'Blockchain Data Streaming', href: 'https://rocknblock.io/blockchain-data-streaming-service' },
  { title: 'Perpetual DEX', href: 'https://rocknblock.io/perpetual-dex' },
  { title: 'Tokenized RWA', href: 'https://rocknblock.io/tokenization' },
  { title: 'Wallet Development', href: 'https://rocknblock.io/cryptocurrency-wallet-development' },
  { title: 'AMM DEX development', href: 'https://rocknblock.io/dex' },
];

export const socialLinks = [
  { title: 'TG', href: 'https://t.me/RocknBlockChannel' },
  { title: 'X', href: 'https://x.com/RockNBlockX' },
  { title: 'LI', href: 'https://www.linkedin.com/company/rock-n-block/' },
];
